import { css } from "styled-components"

export default {
  Focus: css`
    outline: 1px dotted #212121;
    outline: -webkit-focus-ring-color auto 1px;
  `,
}
